import createMetadataAPITypes from '../../utils/api-metadata-types';
import { uniq, isEqual } from 'lodash';
import moment from 'moment';

const options = {
  name: 'incidentFairnessPenaltyOverrides',
  baseType: 'INCIDENT_FAIRNESS_PENALTY_OVERRIDES',
  apiEndpoint: 'incident_fairness_penalty_overrides'
};

const types = createMetadataAPITypes(options);

import createMetadataAPIReducer from '../../utils/api-metadata-reducer';

const initialState = {
  byMembershipAndSkillId: {},
  lastError: null,
  error: null,
  lastFetch: null,
  loading: false
};

// Example structure:
//
// {
//  byMembershipAndSkillId: {
//    123: { // membershipId
//      432: // skillId
//       {
//          membership_id: 123,
//          skill_id: 432,
//          override_value: -1
//       }
//    }
// }

const defaultReducer = createMetadataAPIReducer({ baseType: 'INCIDENT_FAIRNESS_PENALTY_OVERRIDES' });

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS: {
      const overrides = action.payload.data;

      let newById = { ...state.byMembershipAndSkillId };

      const ownerIds = uniq(overrides.map(c => c.membership_id));

      if (action.replace) for (const id of ownerIds) delete newById[id];

      for (const c of overrides) {
        newById[c.membership_id] = newById[c.membership_id] || {};
        newById[c.membership_id][c.skill_id] = c;
      }

      for (const id of ownerIds) {
        // avoid unnecessary updates if values are exactly the same
        if (isEqual(newById[id], state.byMembershipAndSkillId[id])) newById[id] = state.byMembershipAndSkillId[id];
      }

      return {
        ...state,
        byMembershipAndSkillId: newById,
        lastFetch: moment().format(),
        loading: false
      };
    }
    default: {
      return defaultReducer(state, action);
    }
  }
};
